import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sealCheck"
const SealCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.03 10.157 11.25 15.937 7.72 12.407 8.78 11.347 11.25 13.815 15.97 9.096z" />
          <path
            fillRule="evenodd"
            d="M10.908 2.657C11.5 2.03 12.498 2.03 13.091 2.657L14.538 4.191 16.607 3.801C17.458 3.64 18.265 4.227 18.375 5.083L18.643 7.173 20.548 8.076C21.328 8.445 21.636 9.394 21.222 10.151L20.211 12 21.222 13.85C21.636 14.607 21.328 15.556 20.548 15.925L18.643 16.827 18.373 18.917 18.346 19.075C18.175 19.792 17.502 20.28 16.767 20.222L16.609 20.2 14.537 19.81 13.092 21.342 12.976 21.453C12.416 21.933 11.584 21.933 11.024 21.453L10.908 21.343 9.463 19.809 7.39 20.2C6.596 20.35 5.836 19.844 5.654 19.076L5.625 18.917 5.357 16.827 3.452 15.925C2.72 15.58 2.404 14.722 2.708 13.993L2.777 13.85 3.789 12 2.777 10.15C2.363 9.395 2.672 8.445 3.452 8.076L5.357 7.174 5.625 5.084C5.735 4.226 6.543 3.64 7.391 3.8L9.463 4.19zM9.991 5.817 7.114 5.274 6.74 8.18 4.093 9.431 5.5 12 4.093 14.57 6.74 15.82 7.114 18.726 9.99 18.183 12 20.313 14.009 18.184 16.886 18.726 17.26 15.821 19.907 14.57 18.5 12 19.907 9.43 17.259 8.18 16.886 5.273 14.01 5.817 11.999 3.687z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SealCheckIcon
